module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/rooster.e6ff9660.jpg";